import Crud from '../components/VehicleStatus/Crud'
import Entity from '../components/VehicleStatus/Add'

let routes = {
    path: '/vehicleStatus',
    component: resolve => require(['../components/layout/App'], resolve),
    children: [
        {
            path: '/vehicleStatus/add',
            name: 'Novo Status',
            component: Entity
        },
        {
            path: '/vehicleStatus/edit/:id?',
            name: 'Editar Status',
            component: Entity
        },
        {
            path: '/vehicleStatus',
            name: 'Status de Veículos',
            component: Crud
        },
    ]
};

export default routes


// WEBPACK FOOTER //
// ./src/router/vehicleStatus.js